import { KYMW1407Model } from '../kymw1407.model';
import { UpdateImageInfoModel } from '../../kymw1400/vo/update-image-info.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 画像情報を更新する。
 *
 * @export
 * @class UpdateImageInfoService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class UpdateImageInfoService extends PlessJsonResponderSub<any> {

  private vo: UpdateImageInfoModel = null;
  private model: KYMW1407Model = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateImageInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ImageId: this.vo.imageId,
        StartOrderCode: this.vo.startOrderCode,
        EndOrderCode: this.vo.endOrderCode,
        ProcessInstruct: this.vo.processInstruct,
        Remarks: this.vo.remarks,
        CookingExPublish: this.vo.cookingExPublish,
        Priority: this.vo.priority,
        CookingDiv: this.vo.cookingDiv,
        CookingName: this.vo.cookingName,
        MaterialName: this.vo.materialName,
        KeyWord: this.vo.keyWord,
        EventId: this.vo.eventId,
        PhotoContentsDiv: this.vo.photoContentsDiv,
        PhotoInstructContents: this.vo.photoInstructContents,
        PhotoSchedule: this.vo.photoSchedule,
        PhotoStudioId: this.vo.photoStudioId,
        TextCaption: this.vo.textCaption,
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1407Model} model
   * @param {UpdateImageInfoModel} vo
   * @memberof UpdateImageInfoService
   */
  execute(model: KYMW1407Model, vo: UpdateImageInfoModel) {
    this.model = model;
    this.vo = vo;
    this.send('KYMW14updateImageInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} _ レスポンスデータ
   * @memberof UpdateImageInfoService
   */
  success(_: any) {
    this.model.imageInfoDetailChangeFlg = false;
  }
}
